// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__8386Q","col":"Table_col__1GMBu","fulfillmentStatus":"Table_fulfillmentStatus__3bAaE","emailCol":"Table_emailCol__28_4-"};